import React from 'react';
import { Handshake, TreePine, Leaf, Shield } from 'lucide-react';
import { useTranslation } from 'react-i18next';

const About = () => {
  const { t } = useTranslation();
  
  const values = [
    {
      icon: Handshake,
      titleKey: 'about.values.commitment.title',
      textKey: 'about.values.commitment.text'
    },
    {
      icon: TreePine,
      titleKey: 'about.values.origin.title',
      textKey: 'about.values.origin.text'
    },
    {
      icon: Leaf,
      titleKey: 'about.values.sustainability.title',
      textKey: 'about.values.sustainability.text'
    },
    {
      icon: Shield,
      titleKey: 'about.values.reliability.title',
      textKey: 'about.values.reliability.text'
    }
  ];

  return (
    <section id="about" className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="grid lg:grid-cols-2 gap-8 md:gap-12 items-center">
          {/* Left: Video */}
          <div className="relative">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl">
              <video
                src="https://customer-assets.emergentagent.com/job_navarra-supply/artifacts/f9ky5fzn_video%20bueno%20bueno%20pagina%20web.mp4"
                className="w-full h-[300px] md:h-[500px] object-cover"
                autoPlay
                muted
                loop
                playsInline
                disablePictureInPicture
              >
                Tu navegador no soporta la reproducción de videos.
              </video>
            </div>
          </div>

          {/* Right: Content */}
          <div>
            <div className="inline-block mb-4">
              <span className="text-cmv-green font-semibold text-sm uppercase tracking-wider">
                {t('about.label')}
              </span>
            </div>
            
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-4 md:mb-6">
              {t('about.title')}
            </h2>
            
            <p className="text-base md:text-lg text-gray-600 mb-4 md:mb-6 leading-relaxed">
              {t('about.paragraph1')}
            </p>
            
            <p className="text-base md:text-lg text-gray-600 mb-6 md:mb-8 leading-relaxed">
              {t('about.paragraph2')}
            </p>

            {/* Values grid */}
            <div className="grid sm:grid-cols-2 gap-4 md:gap-6">
              {values.map((value, index) => {
                const Icon = value.icon;
                return (
                  <div key={index} className="flex gap-3 md:gap-4">
                    <div className="flex-shrink-0">
                      <div className="w-10 h-10 md:w-12 md:h-12 bg-cmv-green/10 rounded-lg flex items-center justify-center">
                        <Icon className="text-cmv-green" size={20} />
                      </div>
                    </div>
                    <div>
                      <h3 className="font-semibold text-gray-900 mb-1 text-sm md:text-base">{t(value.titleKey)}</h3>
                      <p className="text-xs md:text-sm text-gray-600">{t(value.textKey)}</p>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
